import { render, staticRenderFns } from "./gaudyTitle.vue?vue&type=template&id=fa1b5782&scoped=true"
import script from "./gaudyTitle.vue?vue&type=script&lang=js"
export * from "./gaudyTitle.vue?vue&type=script&lang=js"
import style0 from "./gaudyTitle.vue?vue&type=style&index=0&id=fa1b5782&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1b5782",
  null
  
)

export default component.exports